module.exports = __webpack_public_path__ + "static/media/answerChoose1.271be97b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/answerChoose1.png
// module id = 1715
// module chunks = 0 1